import http from "@/http-common";

/**
 * Service quản lý gia hạn Gói Học Phí (Package Renewal)
 * Base URL: /web/receipt/v1/package-renewals
 *
 * Quy ước:
 * - Không gửi idSchool, idModified, lastModifiedBy – BE tự lấy từ tài khoản đăng nhập.
 * - FE không tự tính ngày renewal, quantity, amount hay invoice.
 * - Ngày dùng định dạng YYYY-MM-DD.
 * - Sau thao tác ghi thành công, reload dữ liệu từ API; không tự chèn bản ghi từ request.
 */
class PackageRenewalService {
  /**
   * Lấy danh sách đăng ký gia hạn của một gói (ACTIVE và PAUSED).
   * CANCELLED/EXPIRED không nằm trong danh sách đăng ký hiện tại từ BE.
   * @param {Object} params - { idPackage: number }
   */
  getList(params) {
    return http.get("receipt/v1/package-renewals", { params });
  }

  /**
   * Đăng ký gia hạn hàng loạt cho nhiều học sinh.
   * BE kiểm tra: package đã bật autoRenew, học sinh là PackageMember active.
   * @param {Object} data - { idPackage: number, studentIds: number[], enrollDate: string }
   */
  register(data) {
    return http.post("receipt/v1/package-renewals/register", data);
  }

  /**
   * Cập nhật trạng thái renewal của một học sinh trong gói.
   * Xác nhận trước PAUSED/CANCELLED ở FE; disable nút trong khi request chạy.
   * @param {Object} data - { idPackage, idStudent, status: RenewalStatus, enabled?: boolean }
   */
  updateStatus(data) {
    return http.put("receipt/v1/package-renewals/status", data);
  }

  /** Hủy đăng ký auto-renew cho nhiều học sinh trong cùng một gói. */
  cancelBulk(data) {
    return http.put("receipt/v1/package-renewals/cancel", data);
  }

  updateStatusBulk(data) {
    return http.put("receipt/v1/package-renewals/status/bulk", data);
  }

  /**
   * Lấy thống kê renewal của gói học phí.
   * Không tự tính lại số liệu ở FE – chỉ hiển thị giá trị trả về từ API.
   * @param {Object} params - { idPackage: number, date?: string (yyyy-MM-dd) }
   */
  getStatistics(params) {
    return http.get("receipt/v1/package-renewals/statistics", { params });
  }
}

export default new PackageRenewalService();
